import React from "react";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { isEqual } from "underscore";
import holdingsDi from "@frameworks/web/components/Reports/HoldingReports/di/servicelocator";
import { getHoldingsUnit } from "./holdingUnits";
const HoldingsQuantity = (props) => {
    const [qtyAsPerSymbol, setQtyAsPerSymbol] = useState(0);
    const holdingsDetails = useSelector((state) => { var _a, _b; return (_b = (_a = state.holdingReport) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.HoldingDetails; }, isEqual);
    const { userID: userID } = useSelector((state) => state.accountDetailsReducer, isEqual);
    useEffect(() => {
        if (holdingsDetails && (holdingsDetails === null || holdingsDetails === void 0 ? void 0 : holdingsDetails.length) == 0) {
            holdingsDi.holdingReport.getHoldingReportData();
        }
        else if ((holdingsDetails === null || holdingsDetails === void 0 ? void 0 : holdingsDetails.length) > 0 && props.symbol) {
            let getQty = getHoldingsUnit(holdingsDetails, props.symbol);
            setQtyAsPerSymbol(getQty);
        }
    }, [holdingsDetails, props.symbol]);
    return (React.createElement(React.Fragment, null, qtyAsPerSymbol ? (React.createElement("span", null,
        React.createElement("i", { className: "edel-icon-stock-briefcase" }),
        React.createElement("span", { className: "holdings-count" }, qtyAsPerSymbol))) : null));
};
export default HoldingsQuantity;
